import React, { Component } from 'react'
import dateformat from 'dateformat'
import config from '../../resource/config.js'

const api = config.apiBaseUrl + 'apbe/fileupload'

class UploadPage extends Component {
    constructor(props)
    {
        super(props)
        this.handleFileInput = this.handleFileInput.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.state = {
            hasError: false,
            buttonValue: true,
            data: 'false',
            userOrgs: '',
            eligibleOrgIds: '',
            cogId: '',
            coordinator: '',
            isLoading: true
        }
    }

    componentDidMount()
    {
        if (typeof _satellite !== 'undefined') window._satellite.track('cbTrack.viewInDom')
    }

    handleFileInput(selectorFiles: FileList)
    {
        if (selectorFiles[0].name.endsWith(".csv") || selectorFiles[0].name.endsWith(".xls") ||
                selectorFiles[0].name.endsWith(".xlsx") || selectorFiles[0].name.endsWith(".CSV") ||
                selectorFiles[0].name.endsWith(".XLS") || selectorFiles[0].name.endsWith(".XLSX"))
        {
            this.fileInput = selectorFiles
            this.setState({ hasError: false })//setting hasError false as it is one of required file content
            this.setState({ buttonValue: false }) //setting buttonValue false so the button will be enabled
        }
        else
        {
            this.setState({ hasError: true })//setting hasError true as it failed one of required file content
            this.setState({ buttonValue: true })//setting buttonValue true so the button will be disabled
        }
    }

    handleSubmit(event)
    {
        this.setState({ buttonValue: true })//setting buttonValue true so the button will be disabled
        event.preventDefault()
        //const formData = new FormData();
        console.log('props upload page', this.props)
        var initialRequestParams = {
            eligibleOrgIds: this.props.eligibleOrgIds || this.props.fDataItems.ELIGIBLE_ORG_IDS,
            userOrgIds: this.props.userOrgIds || this.props.fDataItems.USER_ORG_IDS,
            cognitoId: this.props.cogId || this.props.fDataItems.COGNITO_ID,
            userName: this.props.userName || this.props.fDataItems.USER_NAME,
            uploadType: this.props.UpdateType,
            reqId: this.props.fDataItems ? this.props.fDataItems.REQUEST_ID : undefined,
            fileUploadDate: dateformat(Date.now(), "isoDateTime").toString(),
            fileUploadTime: dateformat(Date.now(), "longTime").toString()
        }

        fetch(api + '?fileName=' + this.fileInput[0].name + '&userName=' +
                initialRequestParams.userName, { // Your POST endpoint
            method: 'GET',
            headers: {
                'X-CB-Catapult-Authentication-Token': this.props.apiAuthHeaders["X-CB-Catapult-Authentication-Token"],
                'X-CB-Catapult-Authorization-Token': this.props.apiAuthHeaders["X-CB-Catapult-Authorization-Token"]
            }
        }).then(response => response.json()) // if the response is a JSON object
                .then(resultUrl => {
                    fetch(resultUrl.url, { // Your POST endpoint
                        method: 'PUT',
                        body: this.fileInput[0],
                        headers: {
                            'Content-Type': 'application/octet-stream',
                            'x-amz-server-side-encryption': 'AES256'
                        }
                    }).then(response => {
                        fetch(api, { // Your POST endpoint
                            method: 'POST',
                            body: JSON.stringify({
                                'fileName': resultUrl.fileName,
                                'params': initialRequestParams,
                                'userFileName': resultUrl.userFileName
                            }),
                            headers: {
                                'X-CB-Catapult-Authentication-Token': this.props.apiAuthHeaders["X-CB-Catapult-Authentication-Token"],
                                'X-CB-Catapult-Authorization-Token': this.props.apiAuthHeaders["X-CB-Catapult-Authorization-Token"]
                            }
                        }).then(response => response.json()) // if the response is a JSON object
                                .then(resp => {
                                    var msg = resp.validationMsg
                                    if (msg === '')
                                    {
                                        if (this.props.UpdateType === '1')
                                        {
                                            window.location.reload()
                                            this.setState({ isLoading: false })//stopping the loading spinner
                                        }
                                        if (this.props.UpdateType === '2' ||
                                                this.props.UpdateType === '3' ||
                                                (this.props.UpdateType === '1'))
                                        {
                                            window.location.replace("/")
                                        }
                                    }
                                    else
                                    {
                                        this.setState({ ErrorMsg: msg })
                                    }
                                })
                    }).catch(err => {
                        console.log(err)
                        this.setState({ ErrorMsg: 'Error: s3 Unable to upload the file' })
                    })
                }).catch(error => {
            console.log(error) // Handle the error response object
            this.setState({ ErrorMsg: 'Error: Unable to upload the file' })
        })
    }

    displayUserEligibleOrgs()
    {
        if (this.props.UpdateType === '1' | this.props.UpdateType === 'undefined')
        {
            //let combinedNamesAndIds = this.props.orgNames.map(x => x + this.props.eligibleOrgIds)
            let orgAiCodes = this.props.orgAiCodes
            let orgNames = this.props.orgNames
            let combinedNamesAndAiCodes = orgNames.map(function (e, i) {
                return e + " " + "(" + orgAiCodes[i] + ")"
            })
            return (<div className="col-xs-7">
                <div className="panel panel-status">
                    <div className="panel-heading">
                        <h4>Eligible Test Centers</h4>
                    </div>
                    <div className="panel-body request-details">
                        <ul>
                            {combinedNamesAndAiCodes ?
                                    (combinedNamesAndAiCodes.map(function (name, idx) {
                                        return (<li key={idx}><strong>{name}</strong></li>)
                                    })) : null}
                        </ul>
                    </div>
                </div>
            </div>)
        }
    }

    render()
    {
        return (<div className="container">
            <div className="row">
                {/* the updateType=1 or UPLOAD_TYPE=1 is First upload
				the updateType=2 or UPLOAD_TYPE=2 is Full replacement
				the updateType=3 or UPLOAD_TYPE=3 is Add on
				the updateType=4 or UPLOAD_TYPE=4 is Cancel
				*/}
                <div className="cb-panel-white">
                    <p>Upload your file by clicking on the <b>Browse</b> button to find the
                        file, selecting the file from your computer, and then clicking
                        the <b>Submit</b> button.</p>
                    <form onSubmit={this.handleSubmit}>
                        {this.displayUserEligibleOrgs()}
                        <div className="col-xs-12">
                            {this.props.UpdateType === '1' | this.props.UpdateType === 'undefined' ?
                                    (<h2>Create Enrollment Request</h2>) :
                                    this.props.UpdateType === '2' ?
                                            (<h2>Upload Full Replacement File</h2>) :
                                            this.props.UpdateType === '3' ?
                                                    (<h2>Upload Add On File</h2>) : (null)}
                            {this.state.hasError ?
                                    <div className="alert-danger" role="alert"><h4>Error:
                                        Invalid File Format. Please upload a .csv,.xls or
                                        .xlsx file.</h4></div> : null}
                            <div className="alert-danger" role="alert">
                                <h4>{this.state.ErrorMsg}</h4>
                            </div>
                        </div>

                        <div className="col-xs-4">
                            <div className="panel panel-status">
                                <div className="panel-heading">
                                    <h4>Upload Enrollment File</h4>
                                </div>
                                <div className="panel-body request-details">
                                    <label htmlFor="browse-file-button"
                                           className="fileContainer">
                                        <strong>Please upload a file</strong>
                                    </label>
                                    <input id="browse-file-button" data-cb-element="no-cb"
                                           onChange={(e) => this.handleFileInput(e.target.files)}
                                           type="file"
                                           accept=".csv, .CSV, .xlsx, .XLSX .xls, .XLS"/>
                                    <br/>
                                    <button className="btn btn-sm btn-secondary"
                                            type="submit" data-cbtrack
                                            disabled={this.state.buttonValue}>Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>)
    }
}

export default UploadPage
